import axios from 'axios';
import { ANONYMOUS_SESSION_KEY, AUTH_TOKEN_KEY, REFRESH_TOKEN_KEY } from '@tools-beaver/shared';

export const apiClient = axios.create({
  baseURL: '/api',
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

// Attach access token if present
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem(AUTH_TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;

  // Pass anonymous session ID
  const sessionId = localStorage.getItem(ANONYMOUS_SESSION_KEY);
  if (sessionId) config.headers['X-Session-Id'] = sessionId;

  return config;
});

// Auto-refresh on 401
apiClient.interceptors.response.use(
  (res) => res,
  async (err) => {
    const original = err.config;
    if (err.response?.status === 401 && !original._retry) {
      original._retry = true;
      const refreshToken = localStorage.getItem(REFRESH_TOKEN_KEY);
      if (refreshToken) {
        try {
          const { data } = await axios.post('/api/auth/refresh', { refreshToken });
          localStorage.setItem(AUTH_TOKEN_KEY, data.data.accessToken);
          original.headers.Authorization = `Bearer ${data.data.accessToken}`;
          return apiClient(original);
        } catch {
          localStorage.removeItem(AUTH_TOKEN_KEY);
          localStorage.removeItem(REFRESH_TOKEN_KEY);
        }
      }
    }
    return Promise.reject(err);
  }
);

export default apiClient;
